import React from 'react'

const NoMach = () => {
  return (
    <div>NoMach</div>
  )
}

export default NoMach;